import { Component, Input, OnInit, Host } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

import { AnalyticsService } from 'rev-shared/analytics/Analytics.Service';
import { EventAnalyticsService } from './EventAnalytics.Service';

import styles from './EventAnalytics.Component.module.less';

@Component({
	selector: 'event-analytics',
	templateUrl: './EventAnalytics.Component.html',
	host: {
		layout: 'column',
		'layout-wrap': 'false'
	},
	providers: [
		EventAnalyticsService
	],
	standalone: false
})
export class EventAnalyticsComponent implements OnInit {
	@Input() public readonly accountId: string;

	private dataFetchContext$: Observable<any>;

	public readonly styles = styles;

	public attendeesByEvent$: Observable<any>;
	public eventsPollingIntervalInSecs: number;
	public kpis$: Observable<any>;
	public status: { [key: string]: boolean };

	constructor(
		@Host() public AnalyticsService: AnalyticsService,
		public EventAnalyticsService: EventAnalyticsService
	) {}

	public ngOnInit(): void {
		this.status = { isLoading: true };
		this.AnalyticsService.getSettings()
			.then(( { webcastRealtimeTableUpdateInterval }) => {
				this.eventsPollingIntervalInSecs = webcastRealtimeTableUpdateInterval;
				this.status = { active: true };
			});
		this.dataFetchContext$ = this.AnalyticsService.dataFetchContext$
			.pipe(
				filter(context => !!context?.startDate),
				distinctUntilChanged()
			);

		this.kpis$ = this.dataFetchContext$
			.pipe(
				switchMap(context => this.EventAnalyticsService.getEventActivityKpis(this.accountId, context))
			);

		this.attendeesByEvent$ = this.dataFetchContext$
			.pipe(
				switchMap(context => this.EventAnalyticsService.getAttendeesByEvent(this.accountId, context))
			);
	}
}
